export default __webpack_public_path__ + "static/media/Encuentra-el-mejor-seguro.3d519ebc.svg";